module.exports = __webpack_public_path__ + "img/setting.b658b153.svg";